export default __webpack_public_path__ + "static/result-checklist-ec996052ad8ad300510f4d3e4fe1f8bf.jpg";